import { g as __rest, b as __assign } from '../../../../tslib.es6-fe064bda.js';
import React__default from 'react';

var NotificationTypeComponent = function (_a) {
    var type = _a.type, message = _a.message, handleIconClick = _a.handleIconClick, rest = __rest(_a, ["type", "message", "handleIconClick"]);
    return (React__default.createElement("div", __assign({ className: "pgc-notification ".concat(type) }, rest),
        React__default.createElement("i", { className: "icon-".concat(type, " pgc-notification-icon"), onClick: function () { return handleIconClick(); } }),
        React__default.createElement("span", { className: 'pgc-notification-text' }, message)));
};

export { NotificationTypeComponent };
